import React, { ReactNode } from 'react';
import { makeStyles, Typography } from '@material-ui/core';

interface ErrorPageProps {
  title: string;
  text: string;
  subText: string;
  icon: ReactNode;
}

const styles = makeStyles(({ palette, spacing }) => ({
  text: {
    textAlign: 'center',
    marginBottom: spacing(4),
  },
  modalContent: {
    padding: spacing(6),
  },
  modal: {
    borderRadius: '16px',
  },
  errorMessage: {
    backgroundColor: palette.error.light,
    borderRadius: spacing(2),
    padding: spacing(4),
  },
  title: {
    marginBottom: spacing(10),
    textAlign: 'initial',
  },
  subTitleText: {
    marginTop: spacing(10),
    textAlign: 'initial',
  },
  subTitleDescText: {
    marginTop: spacing(4),
    textAlign: 'initial',
  },
  icon: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

const ErrorPage = ({ title, text, subText, icon }: ErrorPageProps) => {
  const classes = styles();

  return (
    <div className={classes.errorMessage}>
      <Typography className={classes.title} variant="h1">
        {title}
      </Typography>
      <div className={classes.icon}>{icon}</div>
      {text && (
        <Typography className={classes.subTitleText} variant="body1" component="h1">
          {text}
        </Typography>
      )}
      <Typography className={classes.subTitleDescText} variant="h3" component="h1">
        {subText}
      </Typography>
    </div>
  );
};

export default ErrorPage;
